import React, { useState } from "react";
import PropTypes from "prop-types";
import { Button } from 'components/common';
import UnderlineInput from "../common/UnderlineInput";
import Clickable from "../common/Clickable";

/**
 * "Mark as paid" for a Non-HSBC payment the Payment Accountant made outside the Portal:
 * bank reference + note, both optional. Used on the Processing step of the approval
 * progress and in the ERP & bank card.
 */
const MarkPaidForm = ({ busy = false, onMarkPaid, className = "" }) => {
  const [open, setOpen] = useState(false);
  const [reference, setReference] = useState("");
  const [note, setNote] = useState("");

  const reset = () => { setOpen(false); setReference(""); setNote(""); };
  const save = async () => {
    const ok = await onMarkPaid({ reference: reference.trim(), note: note.trim() });
    if (ok) reset();
  };

  if (!open) {
    return <Button size="sm" className={className} disabled={busy} onClick={() => setOpen(true)}>Mark as paid</Button>;
  }
  return (
    <div className={`tw-space-y-2 ${className}`}>
      <UnderlineInput aria-label="Payment reference" value={reference} onChange={(e) => setReference(e.target.value)}
        placeholder="Bank reference / payment order no. (optional)" />
      <UnderlineInput aria-label="Payment note" value={note} onChange={(e) => setNote(e.target.value)}
        placeholder="Note (optional), e.g. paid by BIDV on 22/10" />
      <div className="tw-flex tw-gap-2">
        <Button size="sm" disabled={busy} loading={busy} onClick={save}>Record as paid</Button>
        <Clickable onClick={reset} className="tw-h-8 tw-px-3 tw-text-[12px] tw-text-geist-fg-3">Cancel</Clickable>
      </div>
    </div>
  );
};

MarkPaidForm.propTypes = {
  busy: PropTypes.bool,
  onMarkPaid: PropTypes.func.isRequired,
  className: PropTypes.string,
};

export default MarkPaidForm;
